import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "./client";

export const GET_ACCOUNTS = gql`
  query getAccounts {
    accounts {
      id
      name
      provider
      url
      login

      metrics
    }
  }
`;

export const useAccounts = () => {
  const { data, loading, networkStatus, refetch } = useQuery(GET_ACCOUNTS, {
    client: shiftStreamClient,
    variables: {},
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      throw error;
    },
  });

  const resolvedData = data;

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    accounts: resolvedData?.accounts || [],
    refetch,
  };
};
